/* eslint-disable @typescript-eslint/indent */
import styled from 'styled-components';
import BaseText from '../../../../ui/Text';
import BaseIcon from '../../../../ui/Icon';
import { colors, spacing } from '../../../../../styles/theme';

export const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 60%;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
`;

interface CircleProps {
  color?:
    | 'default'
    | 'primary'
    | 'accent'
    | 'black'
    | 'black90'
    | 'black80'
    | 'black70'
    | 'black50'
    | 'black24'
    | 'red'
    | 'white';
}
const mapColor = {
  accent: 'accent.base',
  default: 'default.base',
  black: 'black.base',
  black90: 'black.90',
  black80: 'black.80',
  black70: 'black.70',
  black50: 'black.50',
  black24: 'black.24',
  primary: 'primary.base',
  red: 'red.base',
  white: 'white.base',
};

export const Circle = styled.div<CircleProps>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border: 1px solid ${({ color = 'black' }: CircleProps) => colors(mapColor[color!])};
  color: ${({ color = 'black' }: CircleProps) => colors(mapColor[color!])};
`;

export const Text = styled(BaseText)`
  width: 70%;
  margin-left: ${spacing('2')};
`;

export const Icon = styled(BaseIcon)`
  float: right;
  line-height: 28px;
  font-size: 22px;
`;
